import { FC, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, IconDefinition } from "@fortawesome/free-solid-svg-icons";

interface ContextMenuProps {
  options: {
    icon: IconDefinition
    label: string
    onClick: () => void
    danger?: boolean
  }[]
}
export const ContextMenu: FC<ContextMenuProps> = props => {
  const [open, setOpen] = useState(false)

  return <div className={"relative"}>
    <button className={`h-8 w-8 border border-slate-200 rounded-sm text-slate-500 ${open ? 'bg-slate-100 hover:bg-slate-200' : 'bg-white hover:bg-slate-50'} text-xs`} onClick={() => setOpen(!open)}>
      <FontAwesomeIcon icon={faEllipsisVertical} />
    </button>

    {/* Menu */}
    {open && <div className={"absolute top-8 z-10 right-0 w-64 bg-white shadow-md rounded-sm border border-slate-200"}>
      {props.options.map((option, i) => {
        return <button key={i} className={"hover:bg-slate-50 w-full flex h-11 items-center px-3"} onClick={() => {
          option.onClick();
          setOpen(false)
        }}>
          <div className={'w-6 flex items-center justify-center'}>
            <FontAwesomeIcon icon={option.icon} className={`text-xs ${option.danger ? 'text-red-600' : 'text-brand-800'}`} />
          </div>
          <span className={`ml-2 font-medium ${option.danger ? 'text-red-700' : 'text-slate-900'}`}>{option.label}</span>
        </button>;
      })}
      {props.options.length === 0 && <div className={"m-4 text-slate-500 text-center"}>
        No options available
      </div>}
    </div>}

    {/* Backdrop */}
    {open && <div className={"fixed inset-0 bg-transparent z-1"} onClick={() => setOpen(false)} />}
  </div>
}
